import { Preview } from '@/models/models';
import React, { useState } from 'react';
import Loader from '@/components/Loaders/LoaderCircle/Loader';

interface SkinPreviewsProps {
    preview: Preview;
    handleSelectPreview: (preview: Preview, approvedImageIndex: number) => void;
    isApproving?: boolean;
    selectedIndex?: number | null;
}

interface PreviewCardLoaderProps {
    overlay?: boolean;
}

const PreviewCardLoader = ({ overlay }: PreviewCardLoaderProps) => (
    <div className={`absolute inset-0 flex items-center justify-center rounded-xl ${overlay ? 'bg-black/40' : ''}`}>
        <Loader isLoading={true} width={32} height={32} color="white" />
    </div>
);

const SkinPreviews = ({preview, handleSelectPreview, isApproving, selectedIndex}: SkinPreviewsProps) => {
    const [loadedImages, setLoadedImages] = useState<boolean[]>(
        new Array(preview.images.length).fill(false)
    );

    const markLoaded = (index: number) => {
        setLoadedImages(prev => {
            const next = [...prev];
            next[index] = true;
            return next;
        });
    };

    return (
        <div className="w-full max-h-full h-full sm:px-3 bg-background rounded-xl flex flex-col flex-start gap-3">
            <p className="flex-initial text-lg sm:text-3xl font-semibold text-center">Select a skin</p>
            <div className="flex-auto min-h-0 grid grid-cols-2 grid-rows-2 place-content-center place-items-stretch gap-3">
                {preview.images.map((image, index) => {
                    const isSelected = selectedIndex === index;
                    const isDisabled = isApproving;
                    const showApproving = isApproving && isSelected;
                    return (
                        <div
                            key={index}
                            className={`relative bg-foreground rounded-xl p-6 bg-contain bg-no-repeat bg-center bg-origin-content transition-opacity ${isDisabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'} ${isApproving && isSelected ? 'opacity-100' : ''}`}
                            style={loadedImages[index] ? { backgroundImage: `url(${image})` } : undefined}
                            onClick={() => !isDisabled && handleSelectPreview(preview, index)}
                        >
                            {!loadedImages[index] && !showApproving && <PreviewCardLoader />}
                            {showApproving && <PreviewCardLoader overlay />}
                            <img
                                src={image}
                                onLoad={() => markLoaded(index)}
                                className="hidden"
                                alt=""
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SkinPreviews;
